import axiosPrivate from "./axiosPrivate";

const getGestionCorreo = (periodo, estado) => {
    return axiosPrivate.get("gestion-correo", {
        params: { periodo, estado }
    })
        .then(response => response.data);
};

const insertGestionCorreo = (data) => {
    return axiosPrivate.post("gestion-correo", data)
        .then(response => response.data);
};

const updateGestionCorreo = (data) => {
    return axiosPrivate.put("gestion-correo", data)
        .then(response => response.data);
};

const deleteGestionCorreo = (data) => {
    return axiosPrivate.delete("gestion-correo", { data })
        .then(response => response.data);
};

export default {
    getGestionCorreo,
    insertGestionCorreo,
    updateGestionCorreo,
    deleteGestionCorreo
};